<h1 mat-dialog-title>Rinderpassscan-PDF importieren</h1>

<div mat-dialog-content>
    <h5>PDF Datei mit den Rinderp&auml;ssen ausw&auml;hlen (Größe max. 100MB)</h5>
    <h5>Bitte immer nur einen Rinderpass pro PDF-Seite einscannen.</h5>

    <mat-radio-group [formControl]="scanProfilCtrl" class="scan-profil-group" [disabled]="isLoading">
        <mat-radio-button value="ear_tag_only">Schnell – Ohrmarke + Herkunft (empfohlen)</mat-radio-button>
        <mat-radio-button value="full">Vollscan – alle Felder (langsamer)</mat-radio-button>
    </mat-radio-group>
    <p class="scan-profil-hint" *ngIf="scanProfilCtrl.value === 'ear_tag_only'">
        Ohrmarke und Herkunftsbetrieb (VVVO-Barcode) werden gelesen; weitere Pass-Felder nur im Vollscan.
    </p>
    <p class="scan-profil-hint" *ngIf="scanProfilCtrl.value === 'full'">
        Alle Pass-Felder werden gelesen; bei Fehlern können alle Daten im Dialog nachgetragen werden.
    </p>
    <div class="one-row">
        <button mat-flat-button color="accent" [disabled]="isLoading" (click)="this.fileSelector.click()">
            <mat-icon>file_upload</mat-icon>
            Datei auswählen
        </button>
        <span class="spacer"></span>
    </div>
    <input
        type="file"
        style="display: none"
        #fileSelector
        (change)="handleFiles($event)"
        accept="application/pdf"
    />
    <p *ngIf="pdfFile">Datei: {{ pdfFile?.name }}</p>

    <div *ngIf="isLoading" class="upload-progress-block">
        <div class="upload-progress-header">
            <span class="upload-progress-label">{{ liveStatusText }}</span>
            <span class="upload-progress-percent">{{ uploadPercent }} %</span>
        </div>
        <mat-progress-bar mode="determinate" color="accent" [value]="uploadPercent"></mat-progress-bar>
    </div>

    <h5>
        Es kann ein Viehh&auml;ndler oder ein Betriebskontakt ausgew&auml;hlt werden, der dann bei allen Tieren
        hinterlegt wird. (optional)
    </h5>
    <div class="selector-row" *ngIf="selectedBetriebskontakte.length === 0">
        <kiene-autocomplete
            #viehhaendlerAutoComplete
            class="no-padding-margin-mat-form-field full-width-field"
            [showClear]="true"
            [showDeleteButton]="false"
            [required]="false"
            [apiUrl]="apiBaseUrl + 'viehhaendler/'"
            [displayFields]="['name']"
            [placeholder]="'Viehhändler'"
            [focus]="false"
            (elementSelected)="onViehhaendlerSelected($event)"
        >
        </kiene-autocomplete>
        <button mat-icon-button color="accent" [disabled]="isLoading" (click)="addViehhaendler()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <div
        class="divider"
        *ngIf="
            selectedBetriebskontakte.length === 0 &&
            (!viehhaendlerCtrl.value || !viehhaendlerCtrl.value?.viehhaendler_id)
        "
    >
        Oder
    </div>
    <div *ngIf="!viehhaendlerCtrl.value?.viehhaendler_id" class="kontakt-section">
        <ng-container *kienePermission="[9601]">
            <div *ngIf="selectedBetriebskontakte.length > 0">
                <kiene-betriebskontakt-card
                    [kontakt]="selectedBetriebskontakte[0]"
                    [config]="betriebskontaktCardConfig"
                    (entfernen)="onBetriebskontaktEntfernen()"
                >
                </kiene-betriebskontakt-card>
            </div>
            <div *ngIf="selectedBetriebskontakte.length === 0">
                <kiene-betriebskontakt-auswahl
                    [config]="betriebskontaktConfig"
                    [selectedKontakte]="selectedBetriebskontakte"
                    (kontaktSelected)="onBetriebskontaktSelected($event)"
                    (kontakteSelected)="onBetriebskontakteSelected($event)"
                >
                </kiene-betriebskontakt-auswahl>
            </div>
        </ng-container>
    </div>

    <mat-form-field style="margin-top: 24px; width: 100%">
        <mat-label>Einstalldatum</mat-label>
        <input
            required
            matInput
            [matDatepicker]="picker"
            [formControl]="kpEinstalldatumCtrl"
            [readonly]="true"
            [disabled]="isLoading"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field style="width: 100%; margin-bottom: 6px" class="no-padding-margin-mat-form-field">
        <mat-label>Bemerkung</mat-label>
        <textarea [disabled]="isLoading" matInput [formControl]="bemerkungCtrl" rows="3"></textarea>
    </mat-form-field>
</div>

<div mat-dialog-actions align="end">
    <button mat-flat-button [disabled]="isLoading" (click)="dialogRef.close()">Schlie&szlig;en</button>
    <button mat-flat-button color="accent" [disabled]="!isValid() || isLoading" (click)="progressScan()">
        Hochladen
    </button>
</div>
